import { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import AddIcon from '@mui/icons-material/Add';
import { Box, Button, Tooltip } from '@mui/material';
import { TFormType } from 'src/@types';
import { ContentBoxButtons, ContentButtonAction } from 'src/layouts/form/FormButton';
import { createSubContentInfos, ISubContentInfos } from 'src/models/management/business/SubContent';

import { SubContentForm } from './SubContentForm';

interface SubContentManagerProps {
  subContentFields: ISubContentInfos[];
  setSubContentFields: React.Dispatch<React.SetStateAction<ISubContentInfos[]>>;
  formType: TFormType;
}

export const SubContentManager: React.FC<SubContentManagerProps> = ({
  subContentFields,
  setSubContentFields,
  formType,
}) => {
  const { t } = useTranslation();
  const { setValue } = useFormContext();
  const [subContentYn, setSubContentYn] = useState<boolean>(subContentFields.length > 0);

  // 서브 컨텐츠 추가
  const handleSubContentAdd = () => {
    setSubContentFields([...subContentFields, createSubContentInfos()]);
    setValue('subContentInfos', [...subContentFields, createSubContentInfos()]);
  };

  // 서브 컨텐츠 삭제
  const handleSubContentDelete = (index: number) => {
    const updatedFields = subContentFields.filter((_, i) => i !== index);
    setValue('subContentInfos', updatedFields);
    setSubContentFields(updatedFields);
    setSubContentYn(updatedFields.length > 0);
  };

  return (
    <>
      {!subContentYn ? (
        <ContentBoxButtons sx={{ mt: 2, mb: 3, justifyContent: 'flex-start' }}>
          <Tooltip
            title={t('business.form.add_sub_content_tooltip')}
            componentsProps={{
              tooltip: {
                sx: {
                  backgroundColor: 'rgba(255, 255, 255, 0.9)',
                  color: 'black',
                  boxShadow: 1,
                  fontSize: '12px',
                },
              },
            }}
          >
            <Button
              size={'small'}
              color={'success'}
              variant={'contained'}
              startIcon={<AddIcon />}
              sx={{ ml: 1 }}
              onClick={() => {
                setSubContentYn(true);
                handleSubContentAdd();
              }}
            >
              {t('business.form.subContentAdd')}
            </Button>
          </Tooltip>
        </ContentBoxButtons>
      ) : (
        <Box sx={{ mt: 2 }}>
          <ContentBoxButtons sx={{ m: 2, justifyContent: 'flex-start' }}>
            <ContentButtonAction onClick={handleSubContentAdd}>
              <AddIcon /> {t('business.form.subContentAdd')}
            </ContentButtonAction>
          </ContentBoxButtons>
          {subContentFields.map((item, i) => (
            <SubContentForm
              key={`subContent-${item.title}-${i}`}
              index={i}
              formType={formType}
              onDelete={() => handleSubContentDelete(i)}
            />
          ))}
        </Box>
      )}
    </>
  );
};
